/**
 * @description
 * Escape html tags to avoid attacks.
 *
 * @param {string} description - Ad description to clean.
 * @returns {string} ReplacedBreakLines.
 */
export default function getCleanHTML(description) {
  const escapeHTML = description
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  return escapeHTML.replace(/\n/gi, '<br />');
}
